import { cn } from '@crossnokaye/ux-common';

import {
  DeviceTypeDetectionVariant,
  useDeviceTypeDetection,
} from '@/ux-common/hooks/use-device-type-detection/use-device-type-detection';

interface PageContentContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export const PageContentContainer = ({
  children,
  className,
  ...props
}: PageContentContainerProps) => {
  const { isMobile } = useDeviceTypeDetection({
    variant: DeviceTypeDetectionVariant.DeviceOnly,
  });

  return (
    <div
      className={cn('@container/page-content relative min-w-0 h-full', {
        'mb-gutter-sm': isMobile,
      })}
      {...props}
    >
      {children}
    </div>
  );
};
